var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function (t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s)
                if (Object.prototype.hasOwnProperty.call(s, p))
                    t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s)
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
            t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2)
        for (var i = 0, l = from.length, ar; i < l; i++) {
            if (ar || !(i in from)) {
                if (!ar)
                    ar = Array.prototype.slice.call(from, 0, i);
                ar[i] = from[i];
            }
        }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback } from 'react';
import './Select.scss';
import Select, { components } from 'react-select';
import { useLocation, useNavigate } from 'react-router-dom';
import UsersIcon from '../../assets/svg/UsersIcon.svg';
import { useAppSelector } from '@/hooks/redux';
var MySelect = function () {
    var _a;
    var location = useLocation();
    var navigate = useNavigate();
    var user = useAppSelector(function (state) { return state.authStich.currentUser; });
    var BodyTextOne = useCallback(function (_a) {
        var title = _a.title, size = _a.size;
        return (_jsx("div", __assign({ style: size ? { fontSize: size } : {}, className: "BodyTextOne" }, { children: title })));
    }, []);
    var CustomSingleValue = useCallback(function (_a) {
        var children = _a.children, props = __rest(_a, ["children"]);
        return (_jsx(components.SingleValue, __assign({}, props, { children: _jsxs("div", __assign({ style: { display: 'flex', alignItems: 'center', gap: '16px', paddingLeft: '16px', marginLeft: '0px', cursor: 'pointer' } }, { children: [_jsx(UsersIcon, {}), children] })) })));
    }, []);
    var CustomInput = useCallback(function (props) {
        return _jsx(components.Input, __assign({}, props, { readOnly: true }));
    }, []);
    var getDefaultOption = function () {
        return options.find(function (option) {
            return option.path === location.pathname;
        }) || { value: 'default', label: _jsx(BodyTextOne, { title: "\u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0438" }) };
    };
    var options = __spreadArray([], (((_a = user === null || user === void 0 ? void 0 : user.role) === null || _a === void 0 ? void 0 : _a.role) === 'сотрудник' ? [
        { value: 'client', label: _jsx(BodyTextOne, { title: "\u041A\u043B\u0438\u0435\u043D\u0442\u044B" }), path: '/clients' }
    ] : [{ value: 'system', label: _jsx(BodyTextOne, { title: "\u0421\u0438\u0441\u0442\u0435\u043C\u0430" }), path: '/system' },
        { value: 'client', label: _jsx(BodyTextOne, { title: "\u041A\u043B\u0438\u0435\u043D\u0442\u044B" }), path: '/clients' }]), true);
    console.log('options', options);
    var handleChange = function (selectedOption) {
        if (selectedOption && selectedOption.path) {
            navigate(selectedOption.path);
        }
    };
    return (_jsx(Select, { components: { Input: CustomInput, SingleValue: CustomSingleValue }, styles: {
            control: function (baseStyles, state) {
                return (__assign(__assign({}, baseStyles), { background: (location.pathname.includes('system') || location.pathname.includes('clients')
                        || state.menuIsOpen) ? '#1A193C' : '#2C274B', borderColor: (location.pathname.includes('system') || location.pathname.includes('clients')
                        || state.menuIsOpen) ? '#1A193C' : '#2C274B', height: '56px', cursor: 'pointer', borderRadius: '8px', boxShadow: 'none', '&:hover': {
                        border: '0px solid #1A193C',
                        backgroundColor: '#1A193C',
                    }, display: 'flex', alignItems: 'center' }));
            },
            option: function (base) {
                return (__assign(__assign({}, base), { color: '#ffff', background: '#1A193C', '&:hover': {
                        backgroundColor: '#E621D3',
                    } }));
            },
            group: function (base) { return (__assign(__assign({}, base), { background: '#1A193C', paddingLeft: '0px', paddingRight: '0px', marginLeft: '0px', marginRight: '0px' })); },
            menuList: function (base) { return (__assign(__assign({}, base), { boxShadow: 'none', color: 'white', borderWidth: '0px', background: '#1A193C', borderBottomLeftRadius: '8px', borderBottomRightRadius: '8px' })); },
            singleValue: function (provided) { return (__assign(__assign({}, provided), { color: 'white', paddingLeft: '0px', marginLeft: '0px', marginRight: '0px', display: 'flex', alignItems: 'center' })); },
            valueContainer: function (provided) { return (__assign(__assign({}, provided), { paddingLeft: '0px', marginLeft: '0px' })); },
            input: function (provided) { return (__assign(__assign({}, provided), { cursor: 'default', width: '0px', padding: '0px', margin: '0px' })); },
            menu: function (provided) { return (__assign(__assign({}, provided), { background: '#1A193C', boxShadow: 'none', borderBottomLeftRadius: '8px', borderBottomRightRadius: '8px', paddingLeft: '0px', paddingRight: '0px', marginLeft: '0px', marginRight: '0px' })); },
            dropdownIndicator: function (base, state) { return (__assign(__assign({}, base), { color: 'white', transform: state.selectProps.menuIsOpen ? 'rotate(180deg)' : 'rotate(0deg)', transition: 'transform 0.2s ease', paddingLeft: '0px', paddingRight: '0px', marginLeft: '0px', marginRight: '20px' })); },
            indicatorSeparator: function (base) { return (__assign(__assign({}, base), { display: 'none' })); },
        }, className: "Select", value: getDefaultOption(), onChange: handleChange, options: options }));
};
export default MySelect;
